import axios from '../utils/axios/axiosApi'

function getJsonData (documentNumber, documentType, email) {
    return ({
        DocumentNumber : documentNumber, 
        DocumentType : documentType, 
        Email : email 
    })
 };

const getTypesDocumentAsync = () => {
    return new Promise((resolve, reject) => {
        axios.get('Param/GetDocumentTypes')
             .then((response) => {
                resolve(response.data);
             })
             .catch((error) => {
                reject(error);
             });
    });
};
    
const validatePersonAsync = (docNumber, docType, email) => {
    return new Promise((resolve, reject) => {
        axios.post('Person/ValidatePerson', getJsonData(docNumber, docType, email))
             .then((response) => {
                resolve(response.data);
             })
             .catch((error) => {
                reject(error);
             });
    });
};

export {
    getTypesDocumentAsync,
    validatePersonAsync
}